import { Button, Modal } from "antd";

const DeleteModal = (props) => {
  const { showModal, setShowModal, deleteAdvertisement } = props;
  return (
    <div>
      <Modal
        title="Delete Post"
        visible={showModal}
        onCancel={() => setShowModal(false)}
        footer={[
          <Button
            key="back"
            onClick={() => setShowModal(false)}
            className="cancel-ad-btn"
          >
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={async () => {
              setShowModal(false);
              await deleteAdvertisement();
            }}
            className="delete-ad-btn"
          >
            Delete
          </Button>,
        ]}
      >
        Are you sure you want to delete this Advertisement?
      </Modal>
    </div>
  );
};

export default DeleteModal;
